import type { FreelancerAddCertificationDocumentPageLocales } from '../types';

const freelancerAddCertificationDocumentPageLocales: FreelancerAddCertificationDocumentPageLocales =
  {
    certificateAdded: 'certificate added',
    certificateName: 'Certificate name',
    dateInvalid: 'The selected date is invalid.',
    fileRequired: 'Upload a proof to save the diploma',
    helperMessage:
      'Add your certificate below. We need a name and proof for that. The validity date is optional.',
    ifApplicable: '(If applicable)',
    noDataMessage:
      'Something went wrong! The necessary resources for this page are not available.',
    noResultFound: 'No results found',
    saveCertificate: 'Save certificate',
    selectDocType: 'No diploma selected.',
    title: 'Add Certificates',
    uploadProof: 'Upload proof',
    validUntil: 'Valid until',
    validUntilRequired: 'A validity date is required for this document',
    wrongFileExtension:
      'Document does not have the correct extension. Upload a PDF file or photo.',
  };

export default freelancerAddCertificationDocumentPageLocales;
